import { IController, ILocationService } from 'angular';
import * as _ from 'lodash';

import { Cohort } from '../../../../../../ng2/shared/constants/cohort.constant';
import { SdcActionsService } from './../../../../flux/sdc-actions.service';
import { ISdcStore } from './../../../../flux/sdc-store.interface';
import { IFilter, TValidSdcViews } from './../../../../sdc-state/sdc-state.typings';

interface IDropdownItem {
  humanName?: string;
  studentYear?: number;
}

export class GradPlanningWizardDropdownCtrl implements IController {
  static inject: string[] = ['SDCStore', 'sdcActions', '$scope', 'ObjectCache', '$location'];

  public cohortDropdown;
  public selectedCohort;
  public uiReady;
  public sdcView: TValidSdcViews = 'wizard';
  public sdcFilter;

  constructor(
    private SDCStore: ISdcStore,
    private sdcActions: SdcActionsService,
    private $scope,
    private ObjectCache,
    private $location: ILocationService,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) this.setUi();
    });
  }

  setUi() {
    this.sdcFilter = this.SDCStore.getFilter();
    this.cohortDropdown = this.generateDropdown(Cohort);
    this.selectedCohort = this.initializeWithFilter(this.sdcFilter);
    this.uiReady = true;
  }

  filterSDCStudentsByCohort(cohort: IDropdownItem): void {
    const selectedCohort = cohort.humanName;
    const isSenior = cohort.studentYear >= 4;

    let newFilter: IFilter;
    if (isSenior) {
      newFilter = this.getFilterForFourthYearCohort();
    } else {
      newFilter = { cohort: [selectedCohort] };
    }

    const sdcView = this.sdcView;
    const sdcKey = this.SDCStore.getSdcKeyFromUiState();
    this.sdcActions.setEntireFilter({ newFilter, sdcKey, sdcView });
    this.setFilterParam(newFilter);
  }

  getFilterForFourthYearCohort(): IFilter {
    const allYears = _.valuesIn(Cohort);

    const seniorYears = _.reduce(
      allYears,
      (acc, year: any) => {
        if (year.studentYear >= 4) acc.push(year.humanName);
        return acc;
      },
      [],
    );

    return { cohort: seniorYears };
  }

  private generateDropdown(Cohort): IDropdownItem[] {
    const years = _.valuesIn(Cohort);
    return _.reduce(
      years,
      (acc, year: any) => {
        if (year.studentYear <= 4) acc.push({ humanName: year.humanName, studentYear: year.studentYear });
        return acc;
      },
      [],
    );
  }

  private initializeWithFilter(filter: IFilter): IDropdownItem {
    let dropdownItem;

    if (filter.cohort && filter.cohort.length > 1) {
      dropdownItem = _.head(this.cohortDropdown);
    } else {
      const humanName = _.head(filter.cohort);
      dropdownItem = _.find(this.cohortDropdown, { humanName });
    }
    this.setFilterParam(filter);
    return dropdownItem;
  }

  private setFilterParam(filter: IFilter): void {
    const filterHash = this.ObjectCache.cacheObject(filter);
    this.$location.search('filter', filterHash).replace();
  }
}
